import { useClaims } from "../../../../../auth/ClaimsProvider";
import { ShiOnePermission } from "../../../../../auth/authorizationTypes";
import { IRootState } from "../../../../../modules";
import { shallowEqual, useSelector } from "react-redux";
import GlobalConstants from "@constants";
import {
  getManagedSecurityGroups,
} from "../../../../../functions/securityGroupHelper";
import { navItemsToShowType } from "@components/Navigation/NavItemsToShowTypes";
import { NavItemsToShow } from "@components/Navigation/NavItemsToShow";
import { selectVisibleAzureCloudReports } from "../../../../../modules/rtk/integrationsCollector/integrationsCollectorSlice";

export function useGetAssetsItemsPermissions() {
  const { getClaimValue, getClaimValueAsNumber, hasPermission, hasRoleIn } =
    useClaims();
  const myTeams = useSelector(
    (state: IRootState) => state.teamRtk.myTeams,
    shallowEqual,
  );

  const isAdmin = hasRoleIn("CustomerAdmin", "ShiAdmin");
  function showEndUserDevices() {
    return isAdmin && hasPermission(ShiOnePermission.managedDevicesRead);
  }
  const accountId = getClaimValueAsNumber("accountId");
  const contosoDemo = accountId === GlobalConstants.demoAccounts.contoso;

  const { cloudContracts } = useSelector((state: IRootState) => state.contract);

  const teamContracts = useSelector(
    (state: IRootState) => state.team.teamContracts,
  );

  const integrationsCollection = useSelector(
    (state: IRootState) => state.integrationsCollection,
    shallowEqual,
  );

  const hasAzureCloudReports = useSelector(selectVisibleAzureCloudReports);

  const userId = getClaimValue("userId");
  const myManagedSecurityGroups = getManagedSecurityGroups(userId, myTeams);

  const navItemsToShow: navItemsToShowType = NavItemsToShow({
    cloudContracts,
    teamContracts,
    integrationsCollection,
    hasAzureCloudReports,
    undefined,
    myManagedSecurityGroups,
  });

  const assetsItems = navItemsToShow.assetItemsToShow;
  const hasVisibleAssetItem = Object.values(assetsItems).some(Boolean);
  const showAssetsSection =
    (hasVisibleAssetItem && !contosoDemo) ||
    showEndUserDevices()

  return { showAssetsSection, assetsItems };
}
